import { FC } from 'react';
import { ConfirmModal } from '@base-app';
import { LeavingPageModalProps } from './LeavingPageModal.types';

const LeavingPageModal: FC<LeavingPageModalProps> = ({
  confirmText,
  declineText,
  description,
  isShowing,
  onCancel,
  onConfirm,
  title,
}) => {
  return (
    <ConfirmModal
      cancelAction={{
        onClick: onCancel,
        text: declineText,
      }}
      description={description}
      confirmAction={{
        onClick: onConfirm,
        text: confirmText,
      }}
      show={isShowing}
      title={title}
    />
  );
};

export default LeavingPageModal;
